export enum NotificationStatusEnum {
  READ = 'read',
  UNREAD = 'unread',
  DELETED = 'deleted'
}